import { getFormattedAddress } from '@sales-center/common'
import { IEntityAppointment } from '@user/store/scheduling'

export function formattedAddress(value: IEntityAppointment) {
  return getFormattedAddress(
    value.serviceLocationAddress?.lineOne ?? '',
    value.serviceLocationAddress?.lineTwo ?? '',
    value.serviceLocationAddress?.city ?? '',
    value.serviceLocationAddress?.state ?? '',
    value.serviceLocationAddress?.postalCode ?? '',
  )
}
